/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     收费方案数据管理
  +--------------------------------------------------------------------------------------
*/

import Vue from 'vue'
import { allSchemeApi } from '@/api/ei/eiApi'

const schemeStore = {
  state: {
    schemesArr: []
  },
  mutations: {
    SET_SCHEMES: (state, schemes) => {
      Vue.set(state, 'schemesArr', schemes)
    }
  },
  actions: {
    // 获取客户收费方案列表信息
    getAllScheme({ commit, state }) {
      return new Promise((resolve, reject) => {
        allSchemeApi().then(res => {
          if (!res.errno) {
            commit('SET_SCHEMES', res.data.list)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}

export default schemeStore
